import { logEvent, getAnalytics } from 'firebase/analytics'
import UserStore from '../stores/UserStore'

// 커스텀 도메인(go-alwayz.ilevit.com)은 카카오톡 인앱브라우저 DNS 캐시 이슈로
// 앱이 직접 안 열리고 앱스토어로 새서 라우팅 컨텍스트를 잃는다. 앱과 동일하게
// AppsFlyer 기본 도메인(alwayz.onelink.me)을 사용한다. 템플릿 shortcode(AXi1) 동일.
const ONELINK_PREFIX = 'https://alwayz.onelink.me/AXi1'

// AppsFlyer OneLink long url을 구성한다.
// 앱(useAppsFlyerDeepLink)은 deep_link_value(또는 af_dp)에 담긴 full URL을
// parseDynamicLink로 파싱하므로, 라우팅 파라미터는 motherLink 쿼리스트링에 싣는다.
const buildOnelinkUrl = ({ itemId, invitorId, teamDealId, shareType }) => {
  const {
    screen,
    utm_source,
    utm_campaign,
    utm_campaign_id,
    utm_adset_id,
    utm_ad_id,
  } = UserStore?.dynamicLinkParams || {}

  const mother = new URLSearchParams()
  mother.set('shareType', shareType)
  if (screen) mother.set('screen', screen)
  if (invitorId) mother.set('alwayzInvitorId', invitorId)
  if (itemId) mother.set('alwayzItemId', itemId)
  if (teamDealId) mother.set('alwayzTeamDealId', teamDealId)
  if (utm_source) mother.set('utm_source', utm_source)
  if (utm_campaign) mother.set('utm_campaign', utm_campaign)
  if (utm_campaign_id) mother.set('utm_campaign_id', utm_campaign_id)
  if (utm_adset_id) mother.set('utm_adset_id', utm_adset_id)
  if (utm_ad_id) mother.set('utm_ad_id', utm_ad_id)
  const motherLink = `alwayz://appLink/?${mother.toString()}`

  const qs = new URLSearchParams()
  qs.set('deep_link_value', motherLink) // 앱이 읽는 메인 deep link
  qs.set('af_dp', motherLink) // 레거시 fallback
  // 현재 배포된 앱은 res.data.link(= 이 OneLink URL)를 1순위로 파싱하므로,
  // 라우팅 파라미터를 top-level에도 실어 deep_link_value 우선순위 수정 전에도 라우팅되게 한다.
  qs.set('shareType', shareType)
  if (itemId) qs.set('alwayzItemId', itemId)
  if (invitorId) qs.set('alwayzInvitorId', invitorId)
  if (teamDealId) qs.set('alwayzTeamDealId', teamDealId)
  if (utm_source) qs.set('pid', utm_source) // media_source 어트리뷰션
  if (utm_campaign) qs.set('c', utm_campaign) // campaign 어트리뷰션

  return `${ONELINK_PREFIX}?${qs.toString()}`
}

const goAppDownload = async (buttonType = false) => {
  if (UserStore.isLoading) return
  UserStore.setIsLoading(true)

  const analytics = getAnalytics()
  const {
    itemId = undefined,
    invitorId = undefined,
    teamDealId = undefined,
  } = UserStore?.dynamicLinkParams
  let shareType = 'alwayzWeb'

  if (itemId) {
    shareType += '_itemShare'
  } else if (buttonType != false) {
    shareType += `_${buttonType}`
  }
  logEvent(analytics, 'click_app_install', { button_type: buttonType })
  UserStore.setIsLoading(false)

  const onelinkUrl = new URLSearchParams(window.location.search).get(
    'onelinkUrl',
  )
  if (onelinkUrl) {
    window.location.href = onelinkUrl
    return
  }

  const onelinkLongUrl = buildOnelinkUrl({
    itemId,
    invitorId,
    teamDealId,
    shareType,
  })

  // OneLink가 OS 분기(iOS/Android/web)를 알아서 처리하므로 UA 감지 불필요
  window.location.href = onelinkLongUrl
}

export default goAppDownload
